import type { ImportProgress } from './qobuzPlaylistImport';

const progressListeners = new Set<(p: ImportProgress) => void>();

export function addQobuzPlaylistImportProgressListener(fn: (p: ImportProgress) => void): void {
  progressListeners.add(fn);
}

export function removeQobuzPlaylistImportProgressListener(fn: (p: ImportProgress) => void): void {
  progressListeners.delete(fn);
}

export function emitQobuzPlaylistImportProgress(progress: ImportProgress): void {
  progressListeners.forEach((fn) => {
    try { fn(progress); } catch { /* ignore */ }
  });
}
